var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwimming = function SvgSwimming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "swimming_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#swimming_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "M1.875 17.276V16.01q.72-.04 1.111-.421.393-.38 1.463-.38t1.524.416 1.251.417q.798 0 1.252-.417T10 15.208t1.532.417 1.26.417 1.243-.417 1.516-.417 1.463.381q.39.381 1.111.42v1.267q-.99-.049-1.398-.433-.41-.385-1.176-.385-.765 0-1.211.417-.445.417-1.548.417t-1.564-.417T10 16.458q-.765 0-1.22.417-.452.417-1.556.417-1.102 0-1.556-.417t-1.22-.417-1.175.385-1.398.433m0-3.75V12.26q.72-.04 1.111-.421.393-.38 1.463-.38t1.53.416q.46.417 1.245.417.798 0 1.252-.417T10 11.458t1.524.417 1.252.417 1.251-.417 1.524-.417 1.463.381q.39.381 1.111.42v1.267q-.99-.049-1.398-.433-.41-.385-1.176-.385-.765 0-1.192.417t-1.567.417q-1.116 0-1.57-.417-.456-.417-1.222-.417-.792 0-1.213.417t-1.563.417q-1.14 0-1.575-.417t-1.2-.417q-.767 0-1.176.385-.41.384-1.398.433m4.244-4.122 2.73-2.73-1.057-1.059q-.68-.68-1.41-.972-.732-.292-1.824-.316V2.708q1.434.024 2.375.356.94.332 1.855 1.247l5.093 5.093q-.258.18-.51.284a1.5 1.5 0 0 1-.587.104 1.7 1.7 0 0 1-1.144-.417q-.49-.417-1.64-.417t-1.64.417a1.7 1.7 0 0 1-1.144.417q-.333 0-.586-.104a2.6 2.6 0 0 1-.511-.284m7.686-6.615q.803 0 1.363.566.56.567.56 1.357 0 .803-.56 1.363t-1.363.56-1.364-.56a1.86 1.86 0 0 1-.56-1.363q0-.791.56-1.357a1.85 1.85 0 0 1 1.364-.566"
  }))));
};
export default SvgSwimming;